// TitleGroups.confirm(groups, opts) — the import step for a Label's titles (James 2026-10-09): every
// release lives in a subdomain workspace (short and simple: rickandmorty, not rickandmortyoriginalsoundtrack)
// and is auto-tagged Film / TV / Game. One row per suggested workspace: cover, name, an editable subdomain,
// a kind chip (tap to cycle; sets every title in it) and, expanded, its titles, each with its own kind
// chip and a "Move to" (another group, or a new subdomain). Styled modal only.
//
// groups: [{ slug, name, image, existing, indexes, kind, kinds: { index: kind } }] from /workspace/title-groups
// opts.items: [{ title, image }] — the releases the indexes point into.
// Resolves [{ slug, name, image, existing, indexes, kinds }] (empty groups dropped) or null when cancelled.
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clean(v) { return String(v || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]/g, '').slice(0, 30); }
  var KINDS = [null, 'film', 'tv', 'game'];
  var KIND_LABEL = { film: 'Film', tv: 'TV', game: 'Game' };
  function nextKind(k) { return KINDS[(KINDS.indexOf(k || null) + 1) % KINDS.length]; }
  function chip(k, attrs) {
    return '<button type="button" class="tg-kind' + (k ? ' is-' + k : '') + '" ' + attrs + ' title="Tag: tap to change">' + (k ? KIND_LABEL[k] : 'No tag') + '</button>';
  }

  function confirm(groupsIn, opts) {
    opts = opts || {};
    var items = opts.items || [];
    // Working copy: every group keeps its indexes + a kind per title.
    var groups = groupsIn.map(function (g) {
      var kinds = {};
      (g.indexes || []).forEach(function (i) { kinds[i] = (g.kinds && g.kinds[i] !== undefined) ? g.kinds[i] : (g.kind || null); });
      return { slug: g.slug, name: g.name, image: g.image, existing: g.existing, indexes: (g.indexes || []).slice(), kinds: kinds, open: false };
    });

    return new Promise(function (resolve) {
      // STEP 2 of the Add modal (James 2026-10-09: "same size modal as the import, close modal 1 open modal 2"):
      // the Add modal's own frame — header, scrolling body, footer — so the step reads as one flow.
      var o = document.createElement('div');
      o.className = 'add-release-modal-overlay tg-step-overlay';
      o.innerHTML =
        '<div class="add-release-modal tg-step">' +
          '<div class="arm-header">' +
            '<div><h2 class="arm-title">' + esc(opts.title || 'Subdomains') + '</h2>' +
              '<div class="arm-sub">' + esc(opts.text || 'Each title goes into a workspace with its own address and a Film, TV or Game tag. Open a workspace to check or move its titles.') + '</div></div>' +
            '<div class="arm-header-actions"><button class="arm-close" data-cancel aria-label="Close"><i class="bi bi-x-lg"></i></button></div>' +
          '</div>' +
          '<div class="arm-body"><div class="tg-list"></div></div>' +
          '<div class="arm-footer">' +
            '<span class="arm-footer-hint restore-slug-status" aria-live="polite"></span>' +
            '<span class="tg-footer-btns">' +
              '<button type="button" class="arm-skip" data-back>' + esc(opts.cancel || 'Back') + '</button>' +
              '<button type="button" class="arm-import-btn" data-ok>' + esc(opts.cta || 'Continue') + '</button>' +
            '</span>' +
          '</div>' +
        '</div>';
      document.body.appendChild(o);
      requestAnimationFrame(function () { o.classList.add('is-visible'); });
      var list = o.querySelector('.tg-list'), status = o.querySelector('.restore-slug-status'), ok = o.querySelector('[data-ok]');
      var done = false;
      function finish(v) { if (done) return; done = true; try { o.remove(); } catch (_) {} resolve(v); }

      function groupKind(g) {
        var n = {}; g.indexes.forEach(function (i) { var k = g.kinds[i]; if (k) n[k] = (n[k] || 0) + 1; });
        var ks = Object.keys(n); if (!ks.length) return null;
        ks.sort(function (a, b) { return n[b] - n[a]; });
        return ks.length > 1 && g.indexes.some(function (i) { return g.kinds[i] !== ks[0]; }) ? 'mixed' : ks[0];
      }
      function render() {
        groups = groups.filter(function (g) { return g.indexes.length; });
        list.innerHTML = groups.map(function (g, gi) {
          var n = g.indexes.length, gk = groupKind(g);
          var single = n === 1 ? (items[g.indexes[0]] || {}).title : null;
          var meta = (single ? esc(single) : n + ' titles') + (g.existing ? ' · existing workspace' : ' · new workspace');
          var head =
            '<div class="tg-row" data-g="' + gi + '">' +
              '<span class="tg-thumb">' + (g.image ? '<img src="' + esc(g.image) + '" alt="">' : '<i class="bi bi-disc"></i>') + '</span>' +
              '<span class="tg-body"><span class="tg-name">' + esc(g.name) + '</span><span class="tg-meta">' + meta + '</span></span>' +
              (gk === 'mixed' ? '<button type="button" class="tg-kind is-mixed" data-gkind="' + gi + '" title="Mixed tags: tap to set them all">Mixed</button>' : chip(gk, 'data-gkind="' + gi + '"')) +
              '<label class="tg-field"><input type="text" data-slug="' + gi + '" value="' + esc(g.slug) + '" spellcheck="false" autocomplete="off" maxlength="30"><span class="tg-suffix">.loud.link</span></label>' +
              '<button type="button" class="tg-toggle' + (g.open ? ' is-open' : '') + '" data-open="' + gi + '" aria-expanded="' + (g.open ? 'true' : 'false') + '" title="Show titles"><i class="bi bi-chevron-down"></i></button>' +
            '</div>';
          var body = !g.open ? '' : '<div class="tg-titles">' + g.indexes.map(function (i) {
            var it = items[i] || {};
            var opts = '<option value="">Move to…</option>' + groups.map(function (h, hi) {
              return hi === gi ? '' : '<option value="g' + hi + '">' + esc(h.slug) + '.loud.link</option>';
            }).join('') + '<option value="new">New subdomain…</option>';
            return '<div class="tg-title">' +
              '<span class="tg-thumb tg-thumb--sm">' + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<i class="bi bi-disc"></i>') + '</span>' +
              '<span class="tg-title-name">' + esc(it.title || '') + '</span>' +
              chip(g.kinds[i], 'data-tkind="' + gi + ':' + i + '"') +
              '<select class="tg-move" data-move="' + gi + ':' + i + '">' + opts + '</select>' +
            '</div>';
          }).join('') + '</div>';
          return '<div class="tg-group">' + head + body + '</div>';
        }).join('');
        validate();
      }
      function validate() {
        var bad = groups.some(function (g) { return clean(g.slug).length < 2; });
        var nT = groups.reduce(function (n, g) { return n + g.indexes.length; }, 0);
        var nNew = groups.filter(function (g) { return !g.existing; }).length;
        status.textContent = bad ? 'Subdomains are 2 to 30 letters or numbers'
          : groups.length + ' workspace' + (groups.length === 1 ? '' : 's') + (nNew && nNew < groups.length ? ' (' + nNew + ' new)' : '') + ' · ' + nT + ' title' + (nT === 1 ? '' : 's');
        status.classList.toggle('is-bad', bad);
        ok.disabled = bad || !groups.length;
        return !bad;
      }

      list.addEventListener('input', function (e) {
        var t = e.target;
        if (t.dataset.slug != null) { groups[+t.dataset.slug].slug = t.value; validate(); }
      });
      list.addEventListener('focusout', function (e) {
        var t = e.target;
        if (t.dataset && t.dataset.slug != null) { var c = clean(t.value); groups[+t.dataset.slug].slug = c; if (c !== t.value) t.value = c; }
      });
      list.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        if (b.dataset.open != null) { var g = groups[+b.dataset.open]; g.open = !g.open; render(); return; }
        if (b.dataset.gkind != null) {
          var gg = groups[+b.dataset.gkind], cur = groupKind(gg);
          var k = nextKind(cur === 'mixed' ? null : cur);
          gg.indexes.forEach(function (i) { gg.kinds[i] = k; });
          render(); return;
        }
        if (b.dataset.tkind != null) {
          var p = b.dataset.tkind.split(':'), tg = groups[+p[0]], ti = +p[1];
          tg.kinds[ti] = nextKind(tg.kinds[ti]);
          render(); return;
        }
      });
      list.addEventListener('change', function (e) {
        var sel = e.target; if (!sel.dataset || sel.dataset.move == null || !sel.value) return;
        var p = sel.dataset.move.split(':'), from = groups[+p[0]], i = +p[1];
        var kind = from.kinds[i];
        from.indexes = from.indexes.filter(function (x) { return x !== i; }); delete from.kinds[i];
        var to;
        if (sel.value === 'new') {
          var it = items[i] || {};
          var base = clean(String(it.title || '').split(/\s*[(:[\]–—]|\s+-\s+/)[0]) || 'title';
          to = { slug: base, name: String(it.title || base).split(/\s*[([]/)[0].trim(), image: it.image || null, existing: null, indexes: [], kinds: {}, open: true };
          groups.push(to);
        } else {
          to = groups[+sel.value.slice(1)]; to.open = true;
        }
        to.indexes.push(i); to.kinds[i] = kind;
        if (!to.image && items[i]) to.image = items[i].image || null;
        render();
      });
      ok.addEventListener('click', function () {
        if (!validate()) return;
        finish(groups.map(function (g) { return { slug: clean(g.slug), name: g.name, image: g.image, existing: g.existing, indexes: g.indexes.slice(), kinds: Object.assign({}, g.kinds) }; }));
      });
      // Back → null with back:true (the caller reopens step 1); close / Escape / outside → null.
      o.querySelector('[data-back]').addEventListener('click', function () { confirm.lastBack = true; finish(null); });
      o.querySelector('[data-cancel]').addEventListener('click', function () { confirm.lastBack = false; finish(null); });
      o.addEventListener('click', function (e) { if (window.overlayDismissClick ? window.overlayDismissClick(e, o) : e.target === o) { confirm.lastBack = false; finish(null); } });
      document.addEventListener('keydown', function esc2(e) { if (done) { document.removeEventListener('keydown', esc2); return; } if (e.key === 'Escape') { confirm.lastBack = false; finish(null); } });
      confirm.lastBack = false;
      render();
    });
  }

  // After importing releases from OTHER labels (via "Show all releases"): offer to treat those labels as
  // the account's own, so the filter learns. One question per import; nothing changes unless confirmed.
  function learnLabels(labels) {
    var uniq = [];
    (labels || []).forEach(function (l) { l = String(l || '').trim(); if (l && uniq.map(function (x) { return x.toLowerCase(); }).indexOf(l.toLowerCase()) < 0) uniq.push(l); });
    if (!uniq.length) return Promise.resolve(0);
    return new Promise(function (resolve) {
      var o = document.createElement('div');
      o.className = 'delete-modal-overlay is-visible';
      o.innerHTML =
        '<div class="delete-modal tg-learn">' +
          '<p class="delete-modal-title">Treat ' + (uniq.length === 1 ? 'this' : 'these') + ' as your label' + (uniq.length === 1 ? '' : 's') + '?</p>' +
          '<p class="delete-modal-text">You added releases from ' + (uniq.length === 1 ? 'a label' : 'labels') + ' outside Your labels. Add ' + (uniq.length === 1 ? 'it' : 'them') + ' and ' + (uniq.length === 1 ? 'its' : 'their') + ' releases will show without Show all releases.</p>' +
          '<div class="tg-learn-list">' + uniq.map(function (l, i) {
            return '<label class="tg-learn-row"><input type="checkbox" data-i="' + i + '" checked> <span>' + esc(l) + '</span></label>';
          }).join('') + '</div>' +
          '<div class="delete-modal-buttons">' +
            '<button type="button" class="delete-modal-btn delete-modal-btn-primary" data-ok>Add to Your labels</button>' +
            '<button type="button" class="delete-modal-btn delete-modal-btn-cancel" data-cancel>Not now</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(o);
      function done(n) { try { o.remove(); } catch (_) {} resolve(n); }
      o.querySelector('[data-cancel]').addEventListener('click', function () { done(0); });
      o.addEventListener('click', function (e) { if (window.overlayDismissClick ? window.overlayDismissClick(e, o) : e.target === o) done(0); });
      o.querySelector('[data-ok]').addEventListener('click', function () {
        var chosen = Array.prototype.filter.call(o.querySelectorAll('input[type=checkbox]'), function (c) { return c.checked; })
          .map(function (c) { return uniq[+c.getAttribute('data-i')]; });
        var chain = Promise.resolve(), ok = 0;
        chosen.forEach(function (l) {
          chain = chain.then(function () {
            return fetch('/account/labels', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ add: l }) })
              .then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) ok++; }).catch(function () {});
          });
        });
        chain.then(function () {
          if (window.showToast) window.showToast(ok ? 'Added to Your labels' : 'Only managers can change Your labels');
          done(ok);
        });
      });
    });
  }

  window.TitleGroups = { confirm: confirm, clean: clean, learnLabels: learnLabels };
})();
